<template>
<div id="app">
    <div
        class="container"
        v-if="isLogin && !this.isJump">
        <div class="menu-header">
            <div class="logo">
                <img src="@/assets/image/logo.png" alt />
                <div>SSO登录管理系统</div>
            </div>
            <!--头部菜单-->
            <el-menu
                v-if="menuList.length"
                :default-active="menuId"
                @select="menuChange"
                mode="horizontal"
                class="main-menu">
                <el-menu-item
                    v-for="item in menuList"
                    :key="item.menuId"
                    :route="item.url"
                    :index="String(item.menuId)">{{item.menuName}}</el-menu-item>
            </el-menu>
            <div class="head-right-wrap">
                <div class="icon-wrap">
                     <el-badge style="margin-right:20px;" is-dot :hidden="!applyList.length && !approvalList.length">
                        <el-popover
                            trigger="click"
                            v-model="popoverVisible"
                            placement="bottom">
                            <i slot="reference" class="el-icon-bell inform-icon" />
                            <div class="todo-list-wrap" v-if="applyList.length">
                                <div class="todo-list-title">
                                    <span>申请</span>
                                    <i class="el-icon-d-arrow-right" @click="toApplyList()" v-if="$route.path !== '/index/selfApply'"></i>
                                </div>
                                <div class="todo-item" @click="toApplyList(item.id)" v-for="item in applyList" :key="item.id">
                                    您的“
                                    <span class="color">{{`${getAuditTypeName(item.auditType)}`}}</span>
                                    ”申请，有新的审核进度了
                                </div>
                            </div>
                            <div class="todo-list-wrap" v-if="approvalList.length">
                                <div class="todo-list-title">审核</div>
                                <div class="todo-item" @click="toApprovalList(item.id)" v-for="item in approvalList" :key="item.id">您有
                                    <span class="color">{{`${item.proposerName}`}}</span>
                                    发起的“
                                    <span class="color">{{`${getAuditTypeName(item.auditType)}`}}</span>
                                   ”申请，待审核
                                </div>
                            </div>
                            <div class="empty" v-if="!applyList.length && !approvalList.length">暂无待处理消息</div>
                        </el-popover>
                     </el-badge>
                    <el-dropdown
                        @command="click"
                        trigger="click">
                        <img class="logo-img" src="@/assets/image/icon.png" alt />
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item disabled>{{userInfo.userName}}</el-dropdown-item>
                            <el-dropdown-item command="goto">权限申请</el-dropdown-item>
                            <el-dropdown-item command="editpwd">修改密码</el-dropdown-item>
                            <el-dropdown-item command="loginType">登录类型</el-dropdown-item>
                            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div class="main">
            <!--左侧菜单栏-->
            <div class="menu-left">
                <el-menu
                    class="aside_menu"
                    v-if="menuLeft.length"
                    :default-active="currenIndex"
                    @select="changeLeftMenu"
                    router>
                    <div class="top"></div>
                    <sub-menu-item
                        v-for="item in menuLeft"
                        :key="item.menuId"
                        :data="item"></sub-menu-item>
                </el-menu>
            </div>
            <!--内容区-->
            <div class="content">
                <div class="content-top">
                    {{title}}
                    <span v-if="showProjectName">—— {{projectName}}</span>
                </div>
                <div class="content-main">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
    <template v-else>
        <router-view />
    </template>
    <edit-password :show.sync="visible" />
    <login-type
        :show.sync="loginTypeShow"
        v-if="loginTypeShow" />
</div>
</template>

<script>
import {
    getLoginInfo,
    getProjects,
    getAllApp,
    logout
} from '@/api'
import { backlog } from '@/views/index/api'
import {
    getCategoryList
} from '@/views/manage/api'
import Emitter from "@/mixins/emitter"
import EditPassword from '@/components/EditPassword'
import SubMenuItem from '@/components/SubMenuItem'
import LoginType from '@/components/LoginType'
import {
    arrayFlat,
    getUrlParam,
    createTag
} from '@/assets/js/utils'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'index',
    data() {
        return {
            //待办处理
            popoverVisible: false,
            //当前菜单id
            menuId: '105',
            //左侧菜单栏id
            title: '系统入口',
            //路由匹配菜单项
            activeIndex: '',
            //修改密码
            visible: false,
            //登录类型
            loginTypeShow: false,
            //扁平化数组
            allMenuList: [],
            menuLeft: [],
            //是否为子系统跳转
            isChild: (getUrlParam().clientId || getUrlParam().client_id) && (getUrlParam().redirectUri || getUrlParam().redirect_uri) ? true : false,
            //三方登录
            isThird: getUrlParam().SAMLRequest || getUrlParam().service ? true : false,
            //申请列表
            applyList: [],
            //审核列表
            approvalList: [],
            //审核状态
            auditStatusList: [{
                value: 0,
                label: '初始化'
            }, {
                value: 1,
                label: '审核中'
            }, {
                value: 2,
                label: '通过审核'
            }, {
                value: 3,
                label: '拒绝审核'
            }, {
                value: 4,
                label: '系统拒绝'
            }, {
                value: 5,
                label: '撤销审核'
            }],
        };
    },
    mixins: [Emitter],
    components: {
        SubMenuItem,
        EditPassword,
        LoginType
    },
    created() {
        //sso登录
        if (this.isLogin && !this.isJump) {
            this.toInit()
            this.$router.push({
                path: '/index',
            })
            if (this.menuList.length) {
                this.allMenuList = arrayFlat(this.menuList, 'children')
            }
        }
        //监听已登录，获取用户信息
        this.$watch('isLogin', (val) => {
            if (this.isJump) {
                return
            }
            if (val) {
                this.$router.push({
                    path: '/index',
                })
                this.toInit()
            } else {
                this.$router.push({
                    path: '/login',
                })
                localStorage.removeItem("user_login")
                localStorage.removeItem('token')
            }
        })
        //系统列表修改
        this.$on('search.projects', this.getProjects)
        //修改登录类型
        this.$on('set.loginType', this.getInfo)
        //监听菜单变化
        this.$watch('menuList', (val) => {
            if (this.isJump) {
                return
            }
            if (val.length) {
                this.allMenuList = arrayFlat(this.menuList, 'children')
            }
            this.menuRedirect(this.$route.path)
            this.changeMenuActive(val)
        })
    },
    computed: {
        ...mapGetters(['userInfo', 'menuList', 'isLogin', 'projectList', 'projectId']),
        currenIndex() {
            return this.activeIndex
        },
        //筛选系统名称
        projectName() {
            if (this.projectList && (this.projectId || this.projectId === 0)) {
                let item = this.projectList.find(item => this.projectId === item.projectId)
                return item && item.projectName
            } else {
                return ''
            }
        },
        //是否显示系统名称
        showProjectName() {
            return ['role', 'menu', 'menuDisabled'].includes(this.$route.name)
        },
        //子系统登录
        isJump() {
            return this.isChild || this.isThird
        }
    },
    methods: {
        //初始化
        toInit() {
            //获取用户信息
            this.getInfo()
            //获取系统列表
            this.getProjects()
            //系统类别
            this.toGetCategoryList()
            //获取应用列表
            this.getAllApp()
        },
        //获取待办列表
        async toGetBacklogList(type) {
            try {
                let { code,result } = await backlog({
                    userId: this.userInfo.userId,
                    type
                })
                if(code === 0) {
                    this[type == 1 ? 'applyList' : 'approvalList'] = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //申请权限
        toGo() {
            createTag('https://taiyouxi.feishu.cn/wiki/Vq1zwlbLti4mZjkcGakcdCaKnMf')
        },
        //获取用户相关信息
        async getInfo() {
            try {
                let result = await getLoginInfo();
                if (result.code === 0) {
                    this.$store.dispatch('getUserInfo', result.result);
                    //获取待办列表
                    this.toGetBacklogList(1)
                    this.toGetBacklogList(2)
                }
            } catch (error) {
                console.log(error);
            }
        },
        //获取系统列表
        async getProjects() {
            try {
                let {
                    result,
                    code
                } = await getProjects();
                if (code === 0) {
                    let index = result.findIndex(item => item.projectId === this.projectId)
                    let obj = {
                        list: result,
                        projectId: this.projectId
                    }
                    if (!this.projectId || index === -1) {
                        obj.projectId = result[0].projectId
                    }
                    this.$store.dispatch('getProjects', obj);
                }
            } catch (error) {
                console.log(error);
            }
        },
        //获取所有应用
        async getAllApp() {
            try {
                let {
                    result,
                    code
                } = await getAllApp();
                if (code === 0) {
                    this.$store.dispatch('getAllApp', result);
                }
            } catch (error) {
                console.log(error);
            }
        },
        //获取分类
        async toGetCategoryList() {
            try {
                this.tableLoading = true;
                let {
                    code,
                    result
                } = await getCategoryList();
                if (code === 0) {
                    this.$store.dispatch('getAllCategory', result);
                }
            } catch (error) {
                console.log(error);
            }
        },
        //切换目录
        menuChange(index) {
            //目录选中
            this.menuId = index
            //左侧菜单栏
            let item = this.menuList.find(item => String(item.menuId) === index)
            this.menuLeft = item.children ? item.children : []
            //菜单选中
            let menu = this.menuLeft[0]
            if (this.menuLeft[0].children) {
                menu = this.menuLeft[0].children[0]
            }
            this.activeIndex = JSON.stringify(menu)
            this.title = menu.menuName
            //跳转目录下第一个子页面
            this.$router.push({
                path: menu.url,
            })
        },
        //切换左侧菜单
        changeLeftMenu(index) {
            this.title = JSON.parse(index).menuName
        },
        //菜单选中项
        changeMenuActive(menuList,path) {
            if (this.$route.meta.menu === false) {
                return
            }
            path = path || window.location.pathname;
            menuList && menuList.length && menuList.some((obj) => {
                obj.children && obj.children.some(item => {
                    if (item.url === path) {
                        this.menuId = String(obj.menuId)
                        this.menuLeft = obj.children
                        this.activeIndex = JSON.stringify(item)
                        this.title = item.menuName
                        return true
                    } else {
                        item.children && item.children.some(i => {
                            if (i.url === path) {
                                this.menuId = String(obj.menuId)
                                this.menuLeft = obj.children
                                this.activeIndex = JSON.stringify(i)
                                this.title = i.menuName
                                return true
                            }
                            return false
                        })
                    }
                    return false
                })
                return false
            })
        },
        //退出登录or修改密码
        click(command) {
            if (command === 'logout') {
                this.logout()
            } else if (command === 'goto') {
                this.toGo()
            } else {
                let key = command !== 'loginType' ? 'visible' : 'loginTypeShow'
                this[key] = true
            }
        },
        //退出登录
        async logout() {
            try {
                let {
                    code
                } = await logout()
                if (code === 0) {
                    this.$store.dispatch("userLogin", false)
                }
            } catch (error) {
                console.log(error)
            }
        },
        //判断菜单权限
        menuRedirect(path) {
            if (!this.allMenuList.length || path === '/' || this.$route.meta.menu === false) {
                return
            }
            let flag = this.allMenuList.findIndex(item => item.url === path) === -1
            if (flag) {
                this.$router.push({
                    path: '/index/entry'
                })
            }
        },
        //工单申请类型
        getAuditTypeName(value) {
            let text = ''
            switch (value) {
                case 1:
                    text = '角色新增权限'
                    break;
                case 2:
                    text = '申请角色'
                    break;
                case 3:
                    text = '新增应用角色'
                    break;
                case 4:
                    text = '角色新增大区'
                    break;
                default:
                    text = '创建角色'
            }
            return text
        },
        //审核状态名称
        getAuditStatusName(value) {
            let item = this.auditStatusList.find(item => item.value === value)
            return item && item.label || value
        },
        //去权限自助页面
        toApplyList(auditId) {
            this.popoverVisible = false
            this.$router.push({
                path: '/index/selfApply',
                query: auditId ? {
                    auditId
                } : {}
            })
            this.changeMenuActive(this.menuList,'/index/selfApply')
        },
        //去权限审核页面
        toApprovalList(auditId) {
            this.popoverVisible = false
            this.$router.push({
                path: '/index/selfApproval',
                query: {
                    auditId
                }
            })
            this.changeMenuActive(this.menuList,'/index/selfApproval')
        }
    },
    watch: {
        //url页面选中菜单项
        $route(to, from) {
            if (this.$route.name !== 'login' && !this.isJump) {
                if (!this.isLogin) {
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                //已登录跳转 重置菜单项
                if (from.name == 'login') {
                    this.changeMenuActive(this.menuList)
                }
                if(this.userInfo.userId) {
                    //获取待办列表
                    this.toGetBacklogList(1)
                    this.toGetBacklogList(2)
                }
            }
        }
    }
};
</script>

<style lang="scss">
body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}

#app {
    .container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #e6e6e6;

        .menu-header {
            width: 100%;
            height: 30px;
            background-color: #e60012;
            padding: 15px 15px 15px 260px;
            position: relative;

            .logo {
                height: 30px;
                position: absolute;
                top: 15px;
                left: 20px;
                line-height: 30px;
                color: rgba(255, 255, 255, .8);
                display: flex;

                img {
                    height: 100%;
                    margin-right: 20px;
                }
            }

            .head-right-wrap {
                position: absolute;
                top: 0;
                right: 300px;
                .icon-wrap {
                    height: 60px;
                    display: flex;
                    align-items: center;
                    .logo-img {
                        height: 30px;
                        cursor: pointer;
                    }
                    .inform-icon {
                        color: white;
                        font-size: 20px;
                        cursor: pointer;
                    }
                }
            }

            .main-menu {
                float: left;
                background: transparent;

                &.el-menu--horizontal {
                    border-bottom: 0 solid #000;

                    &>.el-submenu {
                        .el-submenu__title {
                            height: 30px;
                            line-height: 30px;
                            border-bottom: 0px;
                            color: #fff;

                            &:hover,
                            &:focus {
                                background-color: #e60012;
                                color: #fff;
                            }
                        }

                        &.is-active .el-submenu__title::before {
                            content: '';
                            position: absolute;
                            height: 5px;
                            width: 50px;
                            left: 50%;
                            margin-left: -33px;
                            bottom: 0;
                            margin-bottom: -15px;
                            background-color: #fff;
                        }
                    }

                    &>.el-menu-item {
                        height: 30px;
                        line-height: 30px;
                        border-bottom: 0px;
                        color: #fff;

                        &:hover,
                        &:focus {
                            background-color: #e60012;
                            color: #fff;
                        }

                        &.is-active::before {
                            content: '';
                            position: absolute;
                            height: 5px;
                            width: 50px;
                            left: 50%;
                            margin-left: -25px;
                            bottom: 1px;
                            margin-bottom: -15px;
                            background-color: rgb(253, 230, 231);
                            border-top-left-radius: 3px;
                            border-top-right-radius: 3px;
                        }
                    }
                }

                .el-submenu__title i {
                    color: #fff;
                }
            }
        }

        .main {
            height: calc(100vh - 60px);
            display: flex;

            .menu-left {
                width: 260px;
                height: calc(100vh - 60px);
                background: #fff;

                .el-menu {
                    background-color: #fff;
                    border-right: 0px;

                    &.aside_menu {
                        i {
                            margin-left: -29px;
                        }
                    }

                    .top {
                        height: 30px;
                        padding: 10px 20px;
                    }

                    .el-menu-item {
                        color: #000;

                        &.is-active {
                            color: #E60012;
                            background-color: rgb(253, 230, 231);
                        }
                         &.not-active {
                            color: #000;
                            background-color: transparent;
                        }

                        &:hover {
                            background-color: rgb(253, 230, 231);
                        }
                    }

                    .el-submenu__title {
                        font-weight: 400;
                        color: #000;
                        background-color: #f6f8fa;
                    }
                }
            }

            .content {
                box-sizing: border-box;

                .content-top {
                    font-size: 16px;
                    height: 50px;
                    background-color: #fff;
                    border-left: 1px solid #f6f8fa;
                    line-height: 50px;
                    padding-left: 20px;
                    color: #E60012;
                }

                .content-main {
                    background-color: #fff;
                    margin: 20px;
                    width: calc(100vw - 260px - 40px);
                    height: calc(100vh - 50px - 60px - 40px);
                    box-sizing: border-box;
                    padding: 20px;
                    overflow-y: auto;
                }
            }
        }
    }
}

.el-dropdown-menu__item.is-disabled {
    max-width: 60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.todo-list-wrap {
    .todo-list-title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 5px;
        position: relative;
        i {
            position: absolute;
            cursor: pointer;
            right: 0;
        }
    }
    .todo-item {
        line-height: 20px;
        padding: 5px 0;
        cursor: pointer;
    }
    .todo-item:not(:last-child) {
        border-bottom: 1px solid #f0f0f0;
    }
}
.todo-list-wrap:not(:first-child) {
    .todo-list-title {
        padding-top: 20px;
    }
}
.empty {
    text-align: center;
    color: #666;
}
.color {
    color: #F56C6C;
}
</style>
